// videoSource.js — MEDIA_VIDEO_V1 (17/08/2026)
//
// Detection de plateforme, vignette automatique et adresse d'integration,
// partagees par le widget « Video » et le widget « Image + texte ».
//
// Ces fonctions vivaient dans VideoGalleryBlock. Les avoir sorties ici evite
// deux choses : une seconde implementation qui aurait diverge au premier ajout
// de plateforme, et le chargement de toute la galerie video sur une page qui
// n'affiche qu'un simple bloc image + texte.

export function parseVideoSource(url = '') {
  const u = (url || '').trim();
  if (!u) return { kind: 'none' };
  let m = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,20})/i);
  if (m) return { kind: 'youtube', id: m[1] };
  m = u.match(/vimeo\.com\/(?:video\/)?(\d{6,12})/i);
  if (m) return { kind: 'vimeo', id: m[1] };
  m = u.match(/(?:dailymotion\.com\/video\/|dai\.ly\/)([\w]+)/i);
  if (m) return { kind: 'dailymotion', id: m[1] };
  if (/\.(mp4|webm|ogv|mov)(\?.*)?$/i.test(u)) return { kind: 'file', id: null };
  return { kind: 'file', id: null }; // URL inconnue : on tente la balise <video>
}

export function autoThumbnail(source, video) {
  if (video.thumbnail_url) return video.thumbnail_url;
  if (source.kind === 'youtube') return `https://i.ytimg.com/vi/${source.id}/hqdefault.jpg`;
  if (source.kind === 'vimeo') return `https://vumbnail.com/${source.id}.jpg`;
  if (source.kind === 'dailymotion') return `https://www.dailymotion.com/thumbnail/video/${source.id}`;
  return null;
}

export function embedUrl(source) {
  if (source.kind === 'youtube') return `https://www.youtube-nocookie.com/embed/${source.id}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&playsinline=1`;
  if (source.kind === 'vimeo') return `https://player.vimeo.com/video/${source.id}?autoplay=1`;
  if (source.kind === 'dailymotion') return `https://www.dailymotion.com/embed/video/${source.id}?autoplay=1`;
  return null;
}
